module.exports = __webpack_public_path__ + "img/alert.55c48030.svg";